package io.github.dautovicharis.charts.internal.common.theme

import androidx.compose.ui.graphics.Color

val md_theme_light_primary = Color(0xFF4958A9)
val md_theme_light_onPrimary = Color(0xFFFFFFFF)
val md_theme_light_primaryContainer = Color(0xFFDEE0FF)
val md_theme_light_onPrimaryContainer = Color(0xFF00105B)
val md_theme_light_secondary = Color(0xFF90427B)
val md_theme_light_onSecondary = Color(0xFFFFFFFF)
val md_theme_light_secondaryContainer = Color(0xFFFFD8EE)
val md_theme_light_onSecondaryContainer = Color(0xFF3A0030)
val md_theme_light_tertiary = Color(0xFFAE2F34)
val md_theme_light_onTertiary = Color(0xFFFFFFFF)
val md_theme_light_tertiaryContainer = Color(0xFFFFDAD8)
val md_theme_light_onTertiaryContainer = Color(0xFF410006)
val md_theme_light_error = Color(0xFFBA1A1A)
val md_theme_light_errorContainer = Color(0xFFFFDAD6)
val md_theme_light_onError = Color(0xFFFFFFFF)
val md_theme_light_onErrorContainer = Color(0xFF410002)
val md_theme_light_background = Color(0xFFFEFBFF)
val md_theme_light_onBackground = Color(0xFF1B1B1F)
val md_theme_light_surface = Color(0xFFFEFBFF)
val md_theme_light_onSurface = Color(0xFF1B1B1F)
val md_theme_light_surfaceVariant = Color(0xFFE3E1EC)
val md_theme_light_onSurfaceVariant = Color(0xFF46464F)
val md_theme_light_outline = Color(0xFF767680)
val md_theme_light_inverseOnSurface = Color(0xFFF3F0F4)
val md_theme_light_inverseSurface = Color(0xFF303034)
val md_theme_light_inversePrimary = Color(0xFFBAC3FF)
val md_theme_light_shadow = Color(0xFF000000)
val md_theme_light_surfaceTint = Color(0xFF4958A9)
val md_theme_light_outlineVariant = Color(0xFFC6C5D0)
val md_theme_light_scrim = Color(0xFF000000)

val md_theme_dark_primary = Color(0xFFBAC3FF)
val md_theme_dark_onPrimary = Color(0xFF162778)
val md_theme_dark_primaryContainer = Color(0xFF303F90)
val md_theme_dark_onPrimaryContainer = Color(0xFFDEE0FF)
val md_theme_dark_secondary = Color(0xFFFFADE3)
val md_theme_dark_onSecondary = Color(0xFF581149)
val md_theme_dark_secondaryContainer = Color(0xFF742A61)
val md_theme_dark_onSecondaryContainer = Color(0xFFFFD8EE)
val md_theme_dark_tertiary = Color(0xFFFFB3B0)
val md_theme_dark_onTertiary = Color(0xFF68000F)
val md_theme_dark_tertiaryContainer = Color(0xFF8C1520)
val md_theme_dark_onTertiaryContainer = Color(0xFFFFDAD8)
val md_theme_dark_error = Color(0xFFFFB4AB)
val md_theme_dark_errorContainer = Color(0xFF93000A)
val md_theme_dark_onError = Color(0xFF690005)
val md_theme_dark_onErrorContainer = Color(0xFFFFDAD6)
val md_theme_dark_background = Color(0xFF1B1B1F)
val md_theme_dark_onBackground = Color(0xFFE4E1E6)
val md_theme_dark_surface = Color(0xFF1B1B1F)
val md_theme_dark_onSurface = Color(0xFFE4E1E6)
val md_theme_dark_surfaceVariant = Color(0xFF46464F)
val md_theme_dark_onSurfaceVariant = Color(0xFFC6C5D0)
val md_theme_dark_outline = Color(0xFF90909A)
val md_theme_dark_inverseOnSurface = Color(0xFF1B1B1F)
val md_theme_dark_inverseSurface = Color(0xFFE4E1E6)
val md_theme_dark_inversePrimary = Color(0xFF4958A9)
val md_theme_dark_shadow = Color(0xFF000000)
val md_theme_dark_surfaceTint = Color(0xFFBAC3FF)
val md_theme_dark_outlineVariant = Color(0xFF46464F)
val md_theme_dark_scrim = Color(0xFF000000)

val seed = Color(0xFF4A4E69)
